
import { Doughnut, mixins } from 'vue-chartjs'
 
export default
    extends: Doughnut,
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    mounted: ->

        #Colors
        colors = ['#ffffff', 'rgba(1, 1, 1, 0.1)']
        if this.chartData.data.length > 2
            colors = this.chartData.data.map (v, i) ->  "rgba(255, 255, 255, #{1-i/5})"


        # Show an empty circle even if there's no data
        data = JSON.parse JSON.stringify(this.chartData.data)
        data[1] = 1 unless data[1] > 0


        this.renderChart
            labels: this.chartData.labels
            datasets: [
                backgroundColor: colors
                borderColor: 'rgba(0, 0, 0, 0.0)'
                data: data
            ]
        ,
            legend:
                display: false
